import { type ReactNode } from 'react'
import * as styles from './styles'

export { selectors as controlBarSelectors } from './styles'

export type ControlBarProps = Readonly<{
  /** The date lockup, in the middle of the row. */
  center?: ReactNode
  end?: ReactNode
  start?: ReactNode
}>

/**
 * The row under the page header, where each timescale puts the controls that
 * only mean something to it.
 */
export const ControlBar: React.FC<ControlBarProps> = ({
  center,
  end,
  start,
}) => (
  <div className={styles.selectors.root} css={styles.root}>
    <div css={styles.start}>{start}</div>
    <div css={styles.center}>{center}</div>
    <div css={styles.end}>{end}</div>
  </div>
)
ControlBar.displayName = 'Calendar: ControlBar'
